import React, { PureComponent } from 'react';
import { Row, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess } from "../../Services/SecurityService";
import { check, findAllRequerimento } from "../../Services/GeometryUserService";
import { findAllSubstanciaSubstanciaUso } from "../../Services/SubstanciaUsoService";
import { findAllSubstanciaByEnabled } from "../../Services/SubstanciaService";
import { db } from '../../db';
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      hasAccess: false,
      selected: {},
      estados: [],
      fases: [],
      events: [],
      substancias: [],
      data: []
    };
    check();
  }

  loadRequerimento(selected, list = []){
    findAllRequerimento()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        for(let i = 0; i < data.length; i++){
          list.push(data[i]);
        }
        this.setState({ data: list, selected, hasAccess: true });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadRequerimentoLocal(selected){
    let list = [];
    let bd = db.getDB();
    let requirements = bd.requirements;
    if(requirements.length > 0){
      list = requirements;
    }
    this.loadRequerimento(selected, list);
  }

  loadSubstancia(){
    findAllSubstanciaByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadSubstanciaUso(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadSubstanciaUso(substancias){
    findAllSubstanciaSubstanciaUso()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let substanciasUso = [];
        for(let i = 0; i < substancias.length; i++){
          substanciasUso = [];
          for(let j = 0; j < data.substanciaSubstanciaUsoList.length; j++){
            if(substancias[i].id === data.substanciaSubstanciaUsoList[j].substancia.id){
              substanciasUso.push(data.substanciaSubstanciaUsoList[j].substanciaUso);
            }
          }
          substancias[i].substanciasUso = substanciasUso;
        }
        this.setState({ substancias });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_MY_REQUIREMENT_VIEW")){
      this.loadRequerimentoLocal({});
      this.loadSubstancia();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.setState({ selected });
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadRequerimentoLocal(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = false;

    if(this.state.hasAccess){
      if(this.state.selected.name !== null && this.state.selected.name !== undefined){
        disabled = (this.state.selected.id === 0);
        view =  <CrudEdit 
                  selected = {this.state.selected} 
                  substancias = {this.state.substancias}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.meus_requerimento_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.meus_requerimento_form.description')}</h3>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);